import React, { useMemo } from 'react'
import { Stack, Typography, useTheme, Skeleton } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { gql, useQuery } from '@apollo/client'

import { trackEvent } from 'analytics'
import { useSites } from 'store'

export const OPERATION_SITE = gql`
  query CartographyAPsZones($sf_id: ID!) {
    surface_areas: cartographyAPsZones(sf_id: $sf_id) {
      name
      uuid
      maps {
        uuid
        name
        level
        devices {
          uuid
          label
          connected_stations
          radio_enabled
          mac
          position {
            x
            y
          }
        }
      }
    }
  } 
`

const AccessPointZones = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [{selected}] = useSites()
  const navigate = useNavigate()
  const { data, loading } = useQuery(OPERATION_SITE, {
    fetchPolicy: 'network-only',
    variables: {
      sf_id: selected[0]?.sf_id
    },
    skip: selected.length !== 1
  })
  const total = useMemo(() => {
    if (!data) {
      return 0
    }
    let nbDevices = 0
    data.surface_areas.forEach(surface => {
      surface.maps.forEach(child => {
        nbDevices += child.devices.length
      })
    })
    return nbDevices
  }, [data])

  const nbDevicesDisabled = useMemo(() => {
    if (!data) {
      return 0
    }
    let nbDevices = 0
    data.surface_areas.forEach(surface => {
      surface.maps.forEach(child => {
        const devices = child.devices.filter(({ radio_enabled }) => !radio_enabled)
        nbDevices += devices.length
      })
    })
    return nbDevices
  }, [data])

  if (loading) {
    return (
      <Stack
        sx={{
          padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
          border: `1px solid ${theme.palette.grey[200]}`,
          borderRadius: '24px',
          color: '#000000'
        }}
      >
        <Stack direction={'row'} gap={2}>
          <Stack flexGrow={1}>
            <Skeleton width="100%" height={20} />
            <Skeleton width="100%" height={16} sx={{ mt: 0.5 }} />
          </Stack>
          <Skeleton variant="circular" width={32} height={32} sx={{alignSelf: 'center'}}/>
        </Stack>

      </Stack>
    )
  } else if (nbDevicesDisabled === 0) {
    return null
  }
  return (
    <Stack
      sx={{
        padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: '24px',
        cursor: 'pointer',
        color: '#000000'
      }}
      onClick={() => {
        trackEvent('access_point_zones_widget_clicked')
        navigate('/access-point-zones')
      }}
    >
      <Stack justifyContent="space-between" direction="row">
        <Stack gap={.25}>
          <Typography sx={{ fontSize: '14px', color: '#000000' }}>{t('access_point_zones.home_kpis.title')}</Typography>
          <Typography sx={{ fontSize: '11px', color: theme.palette.grey[600] }}>{t('access_point_zones.home_kpis.subtitle')}</Typography>
        </Stack>
        <Stack direction="row" alignSelf="center" alignItems="center" gap={.5}>
          <Typography sx={{ fontSize: '22px', color: '#000000' }}>{nbDevicesDisabled}</Typography>
          <Typography sx={{ fontSize: '12px', color: theme.palette.grey[600] }}>/</Typography>
          <Typography sx={{ fontSize: '12px', color: theme.palette.grey[600] }}>{total}</Typography>
        </Stack>
      </Stack>

    </Stack>
  )
}

export default AccessPointZones